import { DragDropModule } from '@angular/cdk/drag-drop';
import { NgModule } from '@angular/core';
import {
  MatAutocompleteModule,
  MatButtonModule,
  MatButtonToggleModule,
  MatCardModule,
  MatCheckboxModule,
  MatDatepickerModule,
  MatDialogModule,
  MatExpansionModule,
  MatIconModule,
  MatInputModule,
  MatListModule,
  MatMenuModule,
  MatNativeDateModule,
  MatPaginatorModule,
  MatProgressSpinnerModule,
  MatRadioModule,
  MatSelectModule,
  MatSliderModule,
  MatSlideToggleModule,
  MatSnackBarModule,
  MatSortModule,
  MatStepperModule,
  MatTableModule,
  MatTabsModule,
  MatTooltipModule,
} from '@angular/material';

import { NgxMatSelectSearchModule } from 'ngx-mat-select-search';

import { MatChipsModule } from '@angular/material/chips';
import { OwlDateTimeModule, OwlNativeDateTimeModule } from 'ng-pick-datetime';

@NgModule({
  exports: [
    MatInputModule,
    MatSnackBarModule,
    MatMenuModule,
    MatRadioModule,
    MatTableModule,
    MatCheckboxModule,
    MatSliderModule,
    MatSortModule,
    MatPaginatorModule,
    MatDatepickerModule,
    MatNativeDateModule,
    MatButtonModule,
    MatSelectModule,
    MatIconModule,
    MatSlideToggleModule,
    MatDialogModule,
    MatProgressSpinnerModule,
    MatMenuModule,
    OwlDateTimeModule,
    OwlNativeDateTimeModule,
    MatListModule,
    MatTabsModule,
    MatAutocompleteModule,
    MatTooltipModule,
    MatCardModule,
    MatButtonToggleModule,
    MatExpansionModule,
    NgxMatSelectSearchModule,
    MatStepperModule,
    MatChipsModule,
    DragDropModule,
  ],
  imports: [
    MatInputModule,
    MatSnackBarModule,
    MatMenuModule,
    MatRadioModule,
    MatTableModule,
    MatSortModule,
    MatPaginatorModule,
    MatDatepickerModule,
    MatNativeDateModule,
    MatButtonModule,
    MatSelectModule,
    MatCheckboxModule,
    MatIconModule,
    MatSliderModule,
    MatSlideToggleModule,
    MatDialogModule,
    MatProgressSpinnerModule,
    MatMenuModule,
    OwlDateTimeModule,
    MatListModule,
    MatTabsModule,
    MatAutocompleteModule,
    MatTooltipModule,
    MatCardModule,
    MatButtonToggleModule,
    MatExpansionModule,
    NgxMatSelectSearchModule,
    MatStepperModule,
    MatChipsModule,
    DragDropModule,
  ],
})
export class MaterialModule {}
